import request from '@/utils/request';

export function getHotBacklogs() {
  return request({
    url: '/backlogs',
    method: 'GET',
  });
}
